export const envColorMap = {
  development: 'yellow',
  staging: 'red',
  demo: 'blue',
  production: 'purple',
}

export const envName = {
  development: 'Dev',
  staging: 'Stage',
  demo: 'Demo',
  production: 'Prod',
}
